<script>
import FormInput from '@/components/form/FormInput.vue';
import FormInputCPF from 'CPF';
import FormInputSelect from '@/components/form/FormInputSelect.vue';
import AppButton from '@/components/ui/AppButton.vue';
import Icons from '@/components/Icons.vue';
import Modal from '@/components/Modal.vue';
import ProfileMenu from '@/components/profile/ProfileMenu.vue';
import ProfileHeaderInfo from '@/components/profile/ProfileHeaderInfo.vue';
import ProfilePhotoUpload from '@/components/profile/ProfilePhotoUpload.vue';
import ProfileProducts from '@/components/profile/ProfileProducts.vue';
import ProfileSecurity from '@/components/profile/ProfileSecurity.vue';
import MGMComponent from '@/components/mgm/MGMComponent.vue';
import moment from 'moment';
import { mapState } from 'vuex';
import MembersService from '@/services/members.service';
import { buildMgmReferralLink } from '@/services/mgmReferralLink';

export default {

	name: 'Perfil',
	components: {
		FormInput,
		FormInputCPF,
		AppButton,
		Icons,
		Modal,
		FormInputSelect,
		ProfileMenu,
		ProfileHeaderInfo,
		ProfilePhotoUpload,
		ProfileProducts,
		ProfileSecurity,
		MGMComponent
	},

	created() {
		// SEO ======
		document.title = this.$t('meta.minhaArea.title');
		document.querySelector('meta[name="description"]').setAttribute('content', this.$t('meta.minhaArea.description'));
		document.querySelector('meta[name="keywords"]').setAttribute('content', this.$t('meta.minhaArea.keywords'));

		// Definindo as Meta Tags de Open Graph (og:*)
		document.querySelector('meta[property="og:title"]').setAttribute('content', this.$t('meta.minhaArea.title'));
		document.querySelector('meta[property="og:description"]').setAttribute('content', this.$t('meta.minhaArea.description'));
		// // Definindo as Meta Tags do Twitter
		document.querySelector('meta[name="twitter:title"]').setAttribute('content', this.$t('meta.minhaArea.title'));
		document.querySelector('meta[name="twitter:description"]').setAttribute('content', this.$t('meta.minhaArea.description'));
		// SEO ======

		const storeBirthday = this.$store.state?.auth?.user?.birthday;
		let birthdayFormatted = "";

		if (storeBirthday) {
			const dateStr = this.getDateFormated(storeBirthday);
			
			let momentDate = moment(dateStr, "YYYY-MM-DD", true);
			
			if (!momentDate.isValid())
				momentDate = moment(dateStr, "DDMMYYYY", true);
			
			if (momentDate.isValid())
				birthdayFormatted = momentDate.format("DDMMYYYY");
		}

		this.user = {
			id: this.$store.state?.auth?.user.id,
			name: this.$store.state?.auth?.user.name,
			lastName: this.$store.state?.auth?.user.lastName,
			email: this.$store.state?.auth?.user.email,
			birthday: birthdayFormatted,
			member: {
				id: this.$store.state?.auth?.user?.member?.id,
				cellphone: this.$store.state?.auth?.user?.member?.cellphone,
				taxId: this.$store.state?.auth?.user?.member?.taxId,
				genderId: this.$store.state?.auth?.user?.member?.genderId,
				memberAddress: {
					address: this.$store.state?.auth?.user?.memberAddress?.address,
					zipCode: this.$store.state?.auth?.user?.memberAddress?.zipCode,
					complement: this.$store.state?.auth?.user?.memberAddress?.complement,
					number: this.$store.state?.auth?.user?.memberAddress?.number,
					neighborhood: this.$store.state?.auth?.user?.memberAddress?.neighborhood,
					state: this.$store.state?.auth?.user?.memberAddress?.state || '',
					city: this.$store.state?.auth?.user?.memberAddress?.city || ''
				},
			}
		}

		const rawCellphone = this.$store.state?.auth?.user?.member?.cellphone || '';
		if (rawCellphone.includes('*'))
			this.user.member.cellphone = this.cellphoneMasked = this.formatPhoneMask(rawCellphone);

		this.isTaxIdLocked = this.cpfEnabled && this.hasTaxIdValue(this.user.member.taxId);

		this.onState();
		this.getProducts();
		this.loadAvatar();
		this.refreshSavedProfileCompletion();
		this.$store.dispatch('members/fetchMemberGetMemberReferrals');
	},
	data() {
		return {
			activeProfileSection: 'data',
			profileLevel: 2,
			profilePoints: 760,
			profilePointsTarget: 999,
			user: {password: '',},
			states: [],
			cities: [],
			products: [],
			isAvatarModalOpen: false,
			showAvatarGrid: false,
			avatarUrl: null,
			avatarPreview: null,
			avatarFile: null,
			avatarZoom: 1,
			avatarOffsetY: 0,
			avatarOffsetX: 0,
			avatarNaturalWidth: 0,
			avatarNaturalHeight: 0,
			avatarMaskWidth: 460,
			avatarMaskHeight: 238,
			categories: [],
			subCategories: [],
			productFormResetKey: 0,
			sending: false,
			zipCodeError: false,
			zipCodeErrorMessage: '',
			isSavingProfile: false,
			isSavingPassword: false,
			profileUpdateSuccess: false,
			passwordUpdateSuccess: false,
			passwordUpdateError: '',
			isEditingProfile: false,
			isEditingPassword: false,
			isPasswordDirty: false,
			isProductDirty: false,
			profileEditSnapshot: null,
			profileEditSession: 0,
			pendingProfileSection: null,
			unsavedChangesModalOpen: false,
			profileUpdateFeedbackTimer: null,
			passwordUpdateFeedbackTimer: null,
			productUpdateFeedbackTimer: null,
			productUpdateSuccess: '',
			productUpdateError: '',
			productDeleteError: '',
			isTaxIdLocked: false,
			savedProfileCompletion: 0,
			isSavingAvatar: false,
			isSavingProduct: false,
			deletingProductIds: [],
			productDeleteModalOpen: false,
			pendingProductDeleteId: null,
			cellphoneMasked: '',
			taxIdError: false,
		}
	},
	beforeUnmount() {
		if (this.profileUpdateFeedbackTimer)
			window.clearTimeout(this.profileUpdateFeedbackTimer)

		if (this.passwordUpdateFeedbackTimer)
			window.clearTimeout(this.passwordUpdateFeedbackTimer)

		if (this.productUpdateFeedbackTimer)
			window.clearTimeout(this.productUpdateFeedbackTimer)
	},
	watch: {
		'user.member.taxId'(taxId) {
			if (!this.isEditingProfile && this.cpfEnabled && this.hasTaxIdValue(taxId))
				this.isTaxIdLocked = true
		},
		'user.member.memberAddress.zipCode'() {
			this.zipCodeError = false;
			this.zipCodeErrorMessage = '';
		}
	},
	computed: {
		...mapState('members', ['memberGetMemberReferrals', 'memberGetMemberPendingInvites']),
		profilePhotoEnabled() {
			return __PROFILE_PHOTO_ENABLED__
		},
		cpfEnabled() {
			return __CPF_ENABLED__
		},
		isBrazilMarket() {
			return import.meta.env.VITE_BASE_PATH === '/br/'
		},
		profileFullName() {
			return `${this.user?.name || ''} ${this.user?.lastName || ''}`.trim()
		},
		profileMemberCode() {
			return this.$store.state?.auth?.user?.member?.memberGetMemberCode || this.user?.member?.id || ''
		},
		profileCompletion() {
			return this.savedProfileCompletion
		},
		profileLevelName() {
			return this.$t('myArea.headerInfo.levelName.challenger')
		},
		profileLevelRange() {
			return this.$t('myArea.headerInfo.levelRange', { min: 500, max: this.profilePointsTarget })
		},
		profileNextLevelTarget() {
			const currentLevelMaximum = Number(this.profilePointsTarget)
			return Number.isFinite(currentLevelMaximum) ? currentLevelMaximum + 1 : 0
		},
		cellphoneQtd: function () {
			return this.$t('form.labels.telMask').split('#').length - 1
		},
		avatarPreviewStyle() {
			const naturalWidth = this.avatarNaturalWidth
			const naturalHeight = this.avatarNaturalHeight
			const maskWidth = this.avatarMaskWidth
			const maskHeight = this.avatarMaskHeight

			if (!naturalWidth || !naturalHeight || !maskWidth || !maskHeight) {
				return { opacity: 0 }
			}

			const coverScale = Math.max(maskWidth / naturalWidth, maskHeight / naturalHeight)
			const zoom = Number(this.avatarZoom || 1)
			const width = naturalWidth * coverScale * zoom
			const height = naturalHeight * coverScale * zoom

			return {
				width: `${width}px`,
				height: `${height}px`,
				transform: `translate(${this.avatarOffsetX}px, ${this.avatarOffsetY}px)`
			}
		},
		avatarOffsetBounds() {
			const naturalWidth = this.avatarNaturalWidth
			const naturalHeight = this.avatarNaturalHeight
			const maskWidth = this.avatarMaskWidth
			const maskHeight = this.avatarMaskHeight

			if (!naturalWidth || !naturalHeight || !maskWidth || !maskHeight) {
				return { maxX: 0, maxY: 0 }
			}

			const coverScale = Math.max(maskWidth / naturalWidth, maskHeight / naturalHeight)
			const zoom = Number(this.avatarZoom || 1)
			const width = naturalWidth * coverScale * zoom
			const height = naturalHeight * coverScale * zoom

			return {
				maxX: Math.max(0, (width - maskWidth) / 2),
				maxY: Math.max(0, (height - maskHeight) / 2)
			}
		},
		loginValidation: function () {
			return {
				email: !!this.user.email && /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(this.user.email),
				name: !!this.user.name,
				lastName: !!this.user.lastName,
				taxId: !this.cpfEnabled || this.isTaxIdLocked || (!!this.user.member.taxId && /^\d{11}$/.test(this.user.member.taxId)),
				cellphone: !!this.user.member.cellphone && (this.user.member.cellphone === this.cellphoneMasked || this.getRegexCellphone().test(this.user.member.cellphone)),
				birthday: !!this.user.birthday && moment(this.user.birthday, "DDMMYYYY", true).isValid()
					&& moment(this.user.birthday, "DDMMYYYY").isSameOrBefore(moment().subtract(18, "years"), "day"),
				city: !!this.user.member.memberAddress.city,
				state: !!this.user.member.memberAddress.state,
				number: !!this.user.member.memberAddress.number,
				address: !!this.user.member.memberAddress.address,
				zipCode: !!this.user.member.memberAddress.zipCode
			}
		},
		isValid: function () {
			var ret = true
			Object.entries(this.loginValidation).forEach(([key, value]) => {
				if (!value)
					ret = false;
			});
			return ret;
		},
		mgmReferralLink() {
			// .href inclui o base do router (ex.: /br/cadastre-se); .path omite VITE_BASE_PATH
			const signupPath = this.$router.resolve({ name: 'signup' }).href;
			const code = this.$store.state?.auth?.user?.member?.memberGetMemberCode || '';
			return buildMgmReferralLink(window.location.origin, signupPath, code);
		},
		mgmConfirmedActivities() {
			return this.memberGetMemberReferrals || [];
		},
		mgmConfirmedCount() {
			return this.mgmConfirmedActivities.length;
		},
		mgmPendingActivities() {
			return this.memberGetMemberPendingInvites || [];
		},
		mgmPendingCount() {
			return this.mgmPendingActivities.length;
		},
		mgmHasMgmListSection() {
			return this.mgmConfirmedCount > 0 || this.mgmPendingCount > 0;
		}
	},
	methods: {
		getDateFormated(dt) {
			if (dt && dt.indexOf('T') > 0)
				return dt.substring(0, dt.indexOf('T'))

			return dt;
		},
		getRegexCellphone: function () {
			if (!this.regexCellphone)
				this.regexCellphone = new RegExp(`^\\d{${this.cellphoneQtd}}$`)

			return this.regexCellphone
		},
		onCellphoneFocus() {
			if (this.user.member.cellphone === this.cellphoneMasked) this.user.member.cellphone = '';
		},
		onCellphoneBlur() {
			if (!this.user.member.cellphone) this.user.member.cellphone = this.cellphoneMasked;
		},
		formatPhoneMask(value) {
			const mask = this.$t('form.labels.telMask');
			const clean = String(value || '').replace(/[^\d*]/g, '');
			if (!clean || !mask) return clean;
			let out = '', i = 0;
			for (const c of mask) {
				if (i >= clean.length) break;
				out += c === '#' ? clean[i++] : c;
			}
			return out;
		},
		maskCellphone(digits) {
			const c = String(digits || '').replace(/\D/g, '');
			if (c.length < 6) return c;
			return this.formatPhoneMask(c.slice(0, 2) + '*'.repeat(c.length - 6) + c.slice(-4));
		},
		maskTaxId(value) {
			const digits = String(value || '').replace(/\D/g, '')
			if (digits.length !== 11) return value
			return digits.slice(0, 3) + '*'.repeat(8)
		},
		getProducts() {
			if (this.user?.member?.id) {
				this.products = []
				this.$store.dispatch("product/getMemberProducts", this.user.member.id).then(
					(resp) => {
						this.products = resp.data;
					},
					(error) => {
						console.log(error)
					}
				).catch(error => {
					console.log(error)
				});
			}
		},
		loadCategories() {
			this.$store.dispatch("product/getCategories").then(
				(resp) => {
					this.categories = resp.data;
				}
			).catch(error => {
				console.log(error)
			});
		},
		onCategoryChange(categoryId) {
			this.subCategories = [];
			if (categoryId) {
				this.$store.dispatch("product/getSubCategories", categoryId).then(
					(resp) => {
						this.subCategories = resp.data;
					}
				).catch(error => {
					console.log(error)
				});
			}
		},
		saveProduct(product) {
			if (this.isSavingProduct) return;

			if (!product?.subCategoryId || !product?.name)
				return
			this.isSavingProduct = true;
			this.clearProductUpdateFeedback()

			this.$store.dispatch("product/registerProduct", {
				memberId: this.user?.member?.id,
				subCategoryId: product.subCategoryId,
				name: product.name
			}).then(() => {
				this.productFormResetKey += 1;
				this.getProducts();
				this.showProductUpdateFeedback(this.$t('myArea.productsSection.saveSuccess'))
			}).catch(error => {
				console.log(error)
				this.productUpdateError = this.$t('myArea.productsSection.requestError')
			}).finally(() => {
				this.isSavingProduct = false;
			});

			this.onClickCard("adicionar-produto", this.user?.member?.id)
		},
		openAvatarModal() {
			this.isAvatarModalOpen = true;
		},
		selectProfilePhoto() {
			if (!this.profilePhotoEnabled) return
			this.$refs.profilePhotoUpload?.selectFile()
		},
		closeAvatarModal() {
			this.isAvatarModalOpen = false
			this.avatarZoom = 1
			this.avatarOffsetX = 0
			this.avatarOffsetY = 0
			this.$nextTick(() => {
				const fileInputs = document.querySelectorAll('.avatar__file');
				fileInputs.forEach(input => {
					if (input) input.value = '';
				});
			});
		},
		toggleAvatarGrid() {
			this.showAvatarGrid = !this.showAvatarGrid;
		},
		measureAvatarMask() {
			this.$nextTick(() => {
				const maskEl = this.$refs.avatarPreviewContainer?.querySelector('.avatar__modal--mask')
				if (!maskEl) return

				const rect = maskEl.getBoundingClientRect()
				this.avatarMaskWidth = rect.width
				this.avatarMaskHeight = rect.height
				this.clampAvatarOffsets()
			})
		},
		clampAvatarOffsets() {
			const { maxX, maxY } = this.avatarOffsetBounds
			this.avatarOffsetX = Math.min(maxX, Math.max(-maxX, Number(this.avatarOffsetX) || 0))
			this.avatarOffsetY = Math.min(maxY, Math.max(-maxY, Number(this.avatarOffsetY) || 0))
		},
		handleAvatarFile(event) {
			const file = event.target.files?.[0];
			if (!file) return;

			const input = event.target;
			this.avatarFile = file;
			const reader = new FileReader();
			reader.onload = e => {
				const preview = e.target.result
				const probe = new Image()
				probe.onload = () => {
					this.avatarPreview = preview
					this.avatarNaturalWidth = probe.naturalWidth
					this.avatarNaturalHeight = probe.naturalHeight
					this.avatarZoom = 1
					this.avatarOffsetY = 0
					this.avatarOffsetX = 0
					this.openAvatarModal()
					this.measureAvatarMask()
				}
				probe.onerror = () => {
					this.avatarPreview = preview
					this.avatarNaturalWidth = 0
					this.avatarNaturalHeight = 0
					this.avatarZoom = 1
					this.avatarOffsetY = 0
					this.avatarOffsetX = 0
					this.openAvatarModal()
				}
				probe.src = preview
			};
			reader.readAsDataURL(file);
			input.value = ''
		},
		saveAvatarPhoto() {
			if (!this.avatarFile || this.isSavingAvatar) return
			this.isSavingAvatar = true
			const resetAvatarSaving = () => {
				this.isSavingAvatar = false
			}

			const img = new Image()
			img.onerror = () => {
				resetAvatarSaving()
			}
			img.onload = () => {
				const previewEl = this.$refs.avatarPreviewContainer
				if (!previewEl) {
					console.error('Container de preview não encontrado')
					resetAvatarSaving()
					return
				}

				const maskEl = previewEl.querySelector('.avatar__modal--mask')
				if (!maskEl) {
					console.error('Máscara de preview não encontrada')
					resetAvatarSaving()
					return
				}

				const rect = maskEl.getBoundingClientRect()
				const maskWidth = rect.width
				const maskHeight = rect.height

				const canvas = document.createElement('canvas')
				canvas.width = maskWidth
				canvas.height = maskHeight

				const ctx = canvas.getContext('2d')
				ctx.fillStyle = '#ffffff';
				ctx.fillRect(0, 0, maskWidth, maskHeight)

				const coverScale = Math.max(maskWidth / img.width, maskHeight / img.height)

				const zoom = Number(this.avatarZoom || 1)
				const offsetX = Number(this.avatarOffsetX || 0)
				const offsetY = Number(this.avatarOffsetY || 0)

				const finalScale = coverScale * zoom

				ctx.save()
				ctx.translate(maskWidth / 2, maskHeight / 2)
				ctx.translate(offsetX, offsetY)
				ctx.scale(finalScale, finalScale)
				ctx.drawImage(img, -img.width / 2, -img.height / 2)
				ctx.restore()

				canvas.toBlob((blob) => {
					if (!blob) {
						resetAvatarSaving()
						return
					}

					const outType = 'image/png'
					const fileName = (this.avatarFile.name || 'avatar').replace(/\.\w+$/, '.png')
					const file = new File([blob], fileName, { type: outType })

					this.$store.dispatch('files/uploadFileToS3', file)
						.then((resp) => {
							const memberId = this.user?.member?.id
							this.$store.dispatch('members/updateMemberAvatar', {
								memberId: memberId,
								body: {
									name: resp.data.name,
									extension: resp.data.extension,
									externalCode: resp.data.externalCode
								}
							}).then((avatarResp) => {
								const fileName = avatarResp?.data?.file?.name;
								const updatedMemberFiles = {
									id: avatarResp?.data?.id,
									memberFileTypeId: avatarResp?.data?.memberFileTypeId,
									file: {
										id: avatarResp?.data?.file?.id,
										name: avatarResp?.data?.file?.name,
										extension: avatarResp?.data?.file?.extension,
									}
								};

								this.$store.commit('auth/updateMemberFiles', updatedMemberFiles)
								this.avatarUrl = this.getAvatarUrl(fileName)
								this.refreshSavedProfileCompletion()

								this.$store.dispatch('discourse/syncUserAvatar', {
									file,
									routeContext: {
										name: this.$route?.name || null,
										params: this.$route?.params || {}
									}
								})
									.catch((error) => {
										console.log(error)
									})
								this.closeAvatarModal();
							})
							.catch((error) => {
								console.log(error)
							})
						})
						.catch((error) => {
							console.log(error)
						})
						.finally(() => {
							resetAvatarSaving()
						})
				}, 'image/png');
			};

			img.src = URL.createObjectURL(this.avatarFile)
		},
		getAvatarUrl(fileName) {
			const url = `${import.meta.env.VITE_BASE_URL_IMG}/files/${fileName}`;
			return url;
		},
		loadAvatar() {
			const storeMemberFiles = this.$store.state?.auth?.user?.memberFiles;
			const fileName = storeMemberFiles?.file?.name;
			if (fileName)
				this.avatarUrl = this.getAvatarUrl(fileName);
		},
		updateZoom(event) {
			this.avatarZoom = Number(event.target.value);
			this.clampAvatarOffsets()
		},
		updateOffsetY(event) {
			this.avatarOffsetY = Number(event.target.value);
			this.clampAvatarOffsets()
		},
		updateOffsetX(event) {
			this.avatarOffsetX = Number(event.target.value);
			this.clampAvatarOffsets()
		},
		onClickCard(content, index) {
			this.$store.dispatch('route/gaEvent', {
				to: window.location.host + this.$route.fullPath,
				element: 'my-area',
				content: content,
				index: index || 0
				});
		},
		startProfileEditing() {
			this.clearProfileUpdateFeedback()
			this.sending = false
			this.profileEditSnapshot = {
				user: JSON.parse(JSON.stringify(this.user)),
				cellphoneMasked: this.cellphoneMasked,
				cities: JSON.parse(JSON.stringify(this.cities))
			}
			this.profileEditSession += 1
			this.isTaxIdLocked = this.cpfEnabled && this.hasTaxIdValue(this.user?.member?.taxId)
			this.isEditingProfile = true
		},
		hasUnsavedProfileChanges() {
			return this.isEditingProfile
				&& !!this.profileEditSnapshot
				&& JSON.stringify(this.user) !== JSON.stringify(this.profileEditSnapshot.user)
		},
		requestProfileSection(section) {
			if (section === this.activeProfileSection) return
			if (this.isSavingProfile || this.isSavingPassword || this.isSavingProduct) return

			const hasUnsavedChanges = this.hasUnsavedProfileChanges()
				|| (this.isEditingPassword && this.isPasswordDirty)
				|| this.isProductDirty

			if (hasUnsavedChanges) {
				this.pendingProfileSection = section
				this.unsavedChangesModalOpen = true
				return
			}

			this.leaveEditingModes()
			this.activeProfileSection = section
		},
		leaveEditingModes() {
			if (this.isEditingProfile) this.cancelProfileEditing()
			if (this.isEditingPassword) this.cancelPasswordEditing()
		},
		closeUnsavedChangesModal() {
			this.unsavedChangesModalOpen = false
			this.pendingProfileSection = null
		},
		discardUnsavedChanges() {
			const section = this.pendingProfileSection

			this.leaveEditingModes()
			if (this.isProductDirty) this.$refs.profileProducts?.discardChanges()

			this.unsavedChangesModalOpen = false
			this.pendingProfileSection = null
			if (section) this.activeProfileSection = section
		},
		handlePasswordDirtyChange(value) {
			this.isPasswordDirty = value
		},
		handleProductDirtyChange(value) {
			this.isProductDirty = value
		},
		cancelProfileEditing() {
			if (this.isSavingProfile) return

			if (this.profileEditSnapshot) {
				this.user = this.profileEditSnapshot.user
				this.cellphoneMasked = this.profileEditSnapshot.cellphoneMasked
				this.cities = this.profileEditSnapshot.cities
			}

			this.profileEditSnapshot = null
			this.profileEditSession += 1
			this.sending = false
			this.zipCodeError = false
			this.zipCodeErrorMessage = ''
			this.isTaxIdLocked = this.cpfEnabled && this.hasTaxIdValue(this.user?.member?.taxId)
			this.isEditingProfile = false
		},
		startPasswordEditing() {
			this.clearPasswordUpdateFeedback()
			this.passwordUpdateError = ''
			this.isEditingPassword = true
		},
		cancelPasswordEditing() {
			if (this.isSavingPassword) return

			this.clearPasswordUpdateFeedback()
			this.passwordUpdateError = ''
			this.isEditingPassword = false
			this.isPasswordDirty = false
		},
		clearProfileUpdateFeedback() {
			if (this.profileUpdateFeedbackTimer)
				window.clearTimeout(this.profileUpdateFeedbackTimer)

			this.profileUpdateFeedbackTimer = null
			this.profileUpdateSuccess = false
		},
		showProfileUpdateFeedback() {
			this.clearProfileUpdateFeedback()
			this.profileUpdateSuccess = true
			this.profileUpdateFeedbackTimer = window.setTimeout(() => {
				this.profileUpdateSuccess = false
				this.profileUpdateFeedbackTimer = null
			}, 3000)
		},
		clearPasswordUpdateFeedback() {
			if (this.passwordUpdateFeedbackTimer)
				window.clearTimeout(this.passwordUpdateFeedbackTimer)

			this.passwordUpdateFeedbackTimer = null
			this.passwordUpdateSuccess = false
		},
		showPasswordUpdateFeedback() {
			this.clearPasswordUpdateFeedback()
			this.passwordUpdateSuccess = true
			this.passwordUpdateFeedbackTimer = window.setTimeout(() => {
				this.passwordUpdateSuccess = false
				this.passwordUpdateFeedbackTimer = null
			}, 3000)
		},
		clearProductUpdateFeedback() {
			if (this.productUpdateFeedbackTimer)
				window.clearTimeout(this.productUpdateFeedbackTimer)

			this.productUpdateFeedbackTimer = null
			this.productUpdateSuccess = ''
			this.productUpdateError = ''
		},
		showProductUpdateFeedback(message) {
			this.clearProductUpdateFeedback()
			this.productUpdateSuccess = message
			this.productUpdateFeedbackTimer = window.setTimeout(() => {
				this.productUpdateSuccess = ''
				this.productUpdateFeedbackTimer = null
			}, 3000)
		},
		hasTaxIdValue(taxId) {
			return this.hasProfileFieldValue(taxId)
		},
		hasProfileFieldValue(value) {
			return !!String(value ?? '').trim()
		},
		calculateProfileCompletion() {
			const fields = [
				this.loginValidation.email,
				this.loginValidation.name,
				this.loginValidation.lastName,
				this.loginValidation.cellphone,
				this.loginValidation.birthday,
				this.hasProfileFieldValue(this.user.member.genderId),
				this.loginValidation.city,
				this.loginValidation.state,
				this.loginValidation.number,
				this.loginValidation.address,
				this.loginValidation.zipCode,
				this.hasProfileFieldValue(this.user.member.memberAddress.neighborhood)
			]

			if (this.cpfEnabled)
				fields.push(this.loginValidation.taxId)

			if (this.profilePhotoEnabled)
				fields.push(!!this.avatarUrl)

			const completedFields = fields.filter(Boolean).length
			return fields.length ? Math.round((completedFields / fields.length) * 100) : 0
		},
		refreshSavedProfileCompletion() {
			this.savedProfileCompletion = this.calculateProfileCompletion()
		},
		updateMember() {
			if (!this.isEditingProfile) return
			if (this.isSavingProfile) return
			this.sending = true
			if (!this.isValid) return
			this.isSavingProfile = true

			this.$store.dispatch('route/gaEvent', {
				element: 'my-area',
				content: 'salva-dados',
				index: this.user?.id || 0,
				to: window.location.host + this.$route.fullPath
			})
			
			const body = {
					name: this.user.name,
					email: this.user.email,
					lastName: this.user.lastName,
					birthday: moment(this.user.birthday, "DDMMYYYY").format("YYYY-MM-DD"),
					member:{
						id: this.user.member.id,
						userId: this.user.member.userId,
						cellphone: this.user.member.cellphone === this.cellphoneMasked ? undefined : this.user.member.cellphone,
						taxId: String(this.user.member.taxId || '').includes('*') ? undefined : this.user.member.taxId,
						genderId: this.user.member.genderId,
						isBlocked: this.user.member.isBlocked,
						attemptLogin: this.user.member.attemptLogin,
						isActive: this.user.member.isActive
					},
					memberAddresses: {
						zipCode: this.user.member.memberAddress.zipCode,
						address: this.user.member.memberAddress.address, 
						complement: this.user.member.memberAddress.complement,
						number: this.user.member.memberAddress.number,
						neighborhood: this.user.member.memberAddress.neighborhood,
						city: this.user.member.memberAddress.city,
						state: this.user.member.memberAddress.state 
					}
				}
			
			this.$store.dispatch('members/update', { memberId: this.user.member.id, body: body }	)
				.then(resp => {
					if (this.cpfEnabled && this.user.member.taxId && !String(this.user.member.taxId).includes('*'))
						this.user.member.taxId = this.maskTaxId(this.user.member.taxId)
					
					if (this.user.member.cellphone && this.user.member.cellphone !== this.cellphoneMasked)
						this.user.member.cellphone = this.cellphoneMasked = this.maskCellphone(this.user.member.cellphone);
					
					return this.$store.dispatch('auth/updateUser', this.user)
				})
				.then(() => {
					this.isTaxIdLocked = this.cpfEnabled && this.hasTaxIdValue(this.user.member.taxId)
					this.refreshSavedProfileCompletion()
					this.profileEditSnapshot = null
					this.sending = false
					this.isEditingProfile = false
					this.showProfileUpdateFeedback()
				})
				.catch(e => {
					console.log(e)
					if(e.response?.data?.message === 'taxId-already-exists')
						this.taxIdError = true
				})
				.finally(() => {
					this.isSavingProfile = false
				})
		},
		updatePassword(passwordForm) {
			if (this.isSavingPassword) return

			this.isSavingPassword = true
			this.clearPasswordUpdateFeedback()
			this.passwordUpdateError = ''

			const body = {
				name: this.user.name,
				email: this.user.email,
				originalPassword: passwordForm.originalPassword,
				password: passwordForm.password,
				confirmPassword: passwordForm.repeatPassword,
				lastName: this.user.lastName,
				birthday: moment(this.user.birthday, "DDMMYYYY").format("YYYY-MM-DD"),
				member: {
					id: this.user.member.id,
					userId: this.user.member.userId,
					cellphone: this.user.member.cellphone === this.cellphoneMasked ? undefined : this.user.member.cellphone,
					taxId: String(this.user.member.taxId || '').includes('*') ? undefined : this.user.member.taxId,
					genderId: this.user.member.genderId,
					isBlocked: this.user.member.isBlocked,
					attemptLogin: this.user.member.attemptLogin,
					isActive: this.user.member.isActive
				},
				memberAddresses: {
					zipCode: this.user.member.memberAddress.zipCode,
					address: this.user.member.memberAddress.address,
					complement: this.user.member.memberAddress.complement,
					number: this.user.member.memberAddress.number,
					neighborhood: this.user.member.memberAddress.neighborhood,
					city: this.user.member.memberAddress.city,
					state: this.user.member.memberAddress.state
				}
			}

			this.$store.dispatch('members/update', { memberId: this.user.member.id, body })
				.then(() => {
					this.isEditingPassword = false
					this.showPasswordUpdateFeedback()
				})
				.catch((error) => {
					const apiMessage = error.response?.data?.message
					if(apiMessage === 'original-password-incorrect') {
						this.passwordUpdateError = this.$t('myArea.security.currentPasswordIncorrect')
					}else if(apiMessage === 'new-password-same-as-current') {
						this.passwordUpdateError = this.$t('myArea.security.newPasswordSameAsCurrent')
					}else if(apiMessage === 'password-mismatch') {
						this.passwordUpdateError = this.$t('myArea.security.passwordMismatch')
					}else { 
						this.passwordUpdateError = this.$t('myArea.security.requestError')
					}
				})
				.finally(() => {
					this.isSavingPassword = false
				})
		},
		requestProductDelete(id) {
			if (id == null || this.deletingProductIds.includes(id)) return

			this.clearProductUpdateFeedback()
			this.productDeleteError = ''
			this.pendingProductDeleteId = id
			this.productDeleteModalOpen = true
		},
		closeProductDeleteModal() {
			this.productDeleteModalOpen = false
			this.pendingProductDeleteId = null
			this.productDeleteError = ''
		},
		confirmProductDelete() {
			if (this.pendingProductDeleteId === null) return

			this.deleteProduct(this.pendingProductDeleteId)
		},
		deleteProduct(id) {
			if (this.deletingProductIds.includes(id)) return
			this.deletingProductIds.push(id)
			this.$store.dispatch('product/deleteProduct', id)
				.then(() => {
					this.getProducts()
					this.closeProductDeleteModal()
					this.showProductUpdateFeedback(this.$t('myArea.productsSection.deleteSuccess'))
				})
				.catch(e => {
					console.log(e)
					this.productDeleteError = this.$t('myArea.productsSection.requestError')
				})
				.finally(() => {
					this.deletingProductIds = this.deletingProductIds.filter(productId => productId !== id)
					this.onClickCard("deletar-produto", id)
				})
		},
		onCepBlur() {
			const raw = this.user.member.memberAddress.zipCode || '';
			const clean = raw.replace(/\D/g, '');
			const editSession = this.profileEditSession;

			this.zipCodeError = false;
			this.zipCodeErrorMessage = '';

			if (clean.length === 0 || clean.length !== 8) {
				this.zipCodeError = true;
				this.zipCodeErrorMessage = 'Por favor, preencha seu CEP.';
				return;
			}

			this.$store.dispatch('address/lookupCep', raw)
				.then((result) => {
					if (!this.isEditingProfile || editSession !== this.profileEditSession) return

					if (!result) {
						this.zipCodeError = true;
						this.zipCodeErrorMessage = 'CEP não encontrado. Por favor, preencha o endereço manualmente.';
						return;
					}
					this.user.member.memberAddress.address = result.street;
					this.user.member.memberAddress.neighborhood = result.neighborhood;
			

					this.zipCodeError = false;
					this.zipCodeErrorMessage = '';
				})
				.catch(() => {
					if (!this.isEditingProfile || editSession !== this.profileEditSession) return

					this.zipCodeError = true;
					this.zipCodeErrorMessage = 'CEP não encontrado. Por favor, preencha o endereço manualmente.';
				});
		},
		onState(retryCount = 0) {
			const maxRetries = 2;
			const savedState = this.user.member.memberAddress.state;
			const savedCity = this.user.member.memberAddress.city;
			
			this.$store.dispatch('address/lookupState')
				.then((result) => {
					if (!result || !result.data) {
						if (retryCount < maxRetries) {
							setTimeout(() => this.onState(retryCount + 1), 1000);
							return;
						}
						return;
					}
					
					this.states = result.data;
					
					if (savedState && this.states.length > 0) {
						const foundState = this.states.find(s => 
							s.sigla === savedState || 
							s.sigla?.toUpperCase() === savedState.toUpperCase() ||
							s.nome === savedState ||
							s.nome?.toUpperCase() === savedState.toUpperCase()
						);
						
						if (foundState) {
							this.user.member.memberAddress.state = foundState.sigla;
							this.onStateChange(0, savedCity);
						}
					}
					
					this.zipCodeError = false;
					this.zipCodeErrorMessage = '';
				})
				.catch((e) => {
					if (retryCount < maxRetries) {
						setTimeout(() => this.onState(retryCount + 1), 1000);
					}
				});
		},
			onStateChange(retryCount = 0, savedCity = null, editSession = this.isEditingProfile ? this.profileEditSession : null) {
			if (!this.user.member.memberAddress.state) return;
			
			const maxRetries = 2;
			const cityToFind = savedCity || this.user.member.memberAddress.city;
			const stateSigla = this.user.member.memberAddress.state;
			
			this.$store.dispatch('address/lookupCity', stateSigla)
				.then((result) => {
					if (editSession !== null && (!this.isEditingProfile || editSession !== this.profileEditSession)) return

					if (!result || !result.data) {
						if (retryCount < maxRetries) {
							setTimeout(() => this.onStateChange(retryCount + 1, cityToFind, editSession), 1000);
							return;
						}
						return;
					}
					
					this.cities = result.data;
					
					if (cityToFind && this.cities.length > 0) {
						const foundCity = this.cities.find(c => 
							c.nome?.toUpperCase() === cityToFind.toUpperCase() || 
							c.nome === cityToFind
						);
						
						if (foundCity) {
							this.user.member.memberAddress.city = foundCity.nome;
						}
					}
				})
				.catch((e) => {
					if (editSession !== null && (!this.isEditingProfile || editSession !== this.profileEditSession)) return

					if (retryCount < maxRetries) {
						setTimeout(() => this.onStateChange(retryCount + 1, cityToFind, editSession), 1000);
					}
					});
			},
			handleMgmSendInvite() {
				this.$store.dispatch('members/fetchMemberGetMemberReferrals');
			},
			mgmSendInviteRequest(email) {
				return MembersService.sendMemberGetMemberInvite(email)
			},
			handleMgmCopySuccess(payload) {
				console.log('MGM profile copy-success', payload)
			},
			handleMgmCopyError(payload) {
				console.log('MGM profile copy-error', payload)
			}
		}
	}

</script>

<template>
	<section class="wrapper profile" data-qa="profile-page">
		<Modal
			data-qa="profile-unsaved-changes-modal"
			:is-open="unsavedChangesModalOpen"
			content-class="profile-unsaved-confirmation"
			@close="closeUnsavedChangesModal"
		>
			<template v-slot:title>{{ $t('myArea.unsavedChanges.title') }}</template>
			<p class="profile-unsaved-confirmation__message">{{ $t('myArea.unsavedChanges.message') }}</p>
			<div class="buttons--wrap profile-unsaved-confirmation__actions">
				<AppButton data-qa="profile-unsaved-continue-button" variant="secondary" @click="closeUnsavedChangesModal">
					{{ $t('myArea.unsavedChanges.continueEditing') }}
				</AppButton>
				<AppButton data-qa="profile-unsaved-discard-button" variant="primary" @click="discardUnsavedChanges">
					{{ $t('myArea.unsavedChanges.discard') }}
				</AppButton>
			</div>
		</Modal>

		<!-- MODAL AVATAR =============== -->
		<Modal data-qa="profile-avatar-modal" :is-open="isAvatarModalOpen" @close="closeAvatarModal" class="modal__crop">
			<template v-slot:title>{{ $t('myArea.avatarModalTitle') }}</template>
			<div class="avatar__modal">
				<div class="avatar__modal--preview" ref="avatarPreviewContainer">
					<div class="mask__crop" v-show="showAvatarGrid">
						<img src="@/assets/img/template/grid-crop-2.png" alt="">
					</div>
					<div class="avatar__modal--mask">
						<img data-qa="profile-avatar-preview-image" :src="avatarPreview" :alt="$t('myArea.avatarPreviewAlt')" :style="avatarPreviewStyle" />
					</div>
				</div>
				<div class="avatar__modal--controls">
					<div class="controls__group">
						<p>{{ $t('myArea.avatarZoom') }}</p>
						<div class="bg__range"><input data-qa="profile-avatar-zoom-input" type="range" min="1" max="2" step="0.01" :value="avatarZoom"
								@input="updateZoom" /></div>
					</div>
					<div class="controls__group">
						<p>{{ $t('myArea.avatarAdjustVertical') }}</p>
						<div class="bg__range"><input data-qa="profile-avatar-vertical-input" type="range" :min="-avatarOffsetBounds.maxY" :max="avatarOffsetBounds.maxY" step="1" :value="avatarOffsetY"
								@input="updateOffsetY" /></div>
					</div>
					<div class="controls__group">
						<p>{{ $t('myArea.avatarAdjustHorizontal') }}</p>
						<div class="bg__range"><input data-qa="profile-avatar-horizontal-input" type="range" :min="-avatarOffsetBounds.maxX" :max="avatarOffsetBounds.maxX" step="1" :value="avatarOffsetX"
								@input="updateOffsetX" /></div>
					</div>
					<div class="controls__group">
						<p>{{ $t('myArea.avatarShowGrid') }}</p>
						<div class="controls__actions">
							<button data-qa="profile-avatar-grid-toggle" type="button" class="btn__show__grid" @click="toggleAvatarGrid">
								<Icons :name="showAvatarGrid ? 'eye' : 'eyeSlash'" />
							</button>
						</div>
					</div>
					<div class="controls__actions buttons">
					<AppButton data-qa="profile-avatar-cancel-button" variant="secondary" @click="closeAvatarModal">{{ $t('buttons.cancelar') }}</AppButton>
					<AppButton data-qa="profile-avatar-save-button" variant="primary" @click="saveAvatarPhoto" :disabled="isSavingAvatar" :aria-busy="isSavingAvatar">{{ $t(isSavingAvatar ? 'buttons.saving' : 'buttons.savePhoto') }}</AppButton>
					</div>
				</div>
			</div>
		</Modal>
		<!-- MODAL AVATAR =============== -->

		<!-- MODAL ALERTA DELETAR =============== -->
		<Modal
			data-qa="profile-product-delete-modal"
			:is-open="productDeleteModalOpen"
			content-class="product-delete-confirmation"
			@close="closeProductDeleteModal"
		>
			<template v-slot:title>{{ $t('myArea.modalDeletTitle') }}</template>
			<div class="content--alert product-delete-confirmation__message" v-html="$t('myArea.modalDeletText')">

			</div>
			<p v-if="productDeleteError" class="product-delete-confirmation__error" data-qa="profile-product-delete-error" role="alert">
				<Icons name="exclamation" aria-hidden="true" />
				{{ productDeleteError }}
			</p>
			<div class="buttons--wrap product-delete-confirmation__actions">
				<AppButton data-qa="profile-product-delete-cancel-button" variant="secondary" @click="closeProductDeleteModal">{{ $t('buttons.cancelar') }}</AppButton>
				<AppButton
					data-qa="profile-product-delete-confirm-button"
					variant="primary"
					:disabled="deletingProductIds.includes(pendingProductDeleteId)"
					:aria-busy="deletingProductIds.includes(pendingProductDeleteId)"
					@click="confirmProductDelete"
				>
					{{ $t(deletingProductIds.includes(pendingProductDeleteId) ? 'buttons.deleting' : 'buttons.excluir') }}
				</AppButton>
			</div>
		</Modal>
		<!-- MODAL ALERTA DELETAR =============== -->

		<header class="profile__page-header" data-qa="profile-cover-header">
			<picture aria-hidden="true">
				<source media="(min-width: 48em)" srcset="@/assets/img/profile/profile-cover-desktop.webp">
				<img src="@/assets/img/profile/profile-cover-mobile.webp" alt="">
			</picture>
			<h1>{{ $t('myArea.title') }}</h1>
		</header>

		<ProfileHeaderInfo
			:avatar-url="avatarUrl"
			:full-name="profileFullName"
			:member-code="profileMemberCode"
			:photo-enabled="profilePhotoEnabled"
			:completion="profileCompletion"
			:level="profileLevel"
			:level-name="profileLevelName"
			:level-range="profileLevelRange"
			:points="profilePoints"
			:points-target="profileNextLevelTarget"
			@change-photo="selectProfilePhoto"
		/>
		<ProfileMenu
			:active-item="activeProfileSection"
			@select="requestProfileSection"
		/>

		<ProfileSecurity
			v-show="activeProfileSection === 'security'"
			:email="user.email"
			:is-editing="isEditingPassword"
			:is-saving="isSavingPassword"
			:is-success="passwordUpdateSuccess"
			:request-error="passwordUpdateError"
			@edit="startPasswordEditing"
			@cancel="cancelPasswordEditing"
			@dirty-change="handlePasswordDirtyChange"
			@submit="updatePassword"
		/>

		<!-- [START] FORM PERFIL ==================================== -->
		<section v-show="activeProfileSection === 'data'" class="section__module profile__data-section" data-qa="profile-data-section">
			<div class="module__expand profile__section-card">
				<div class="module__expand--content is-open">

					<form
						class="wrapper__form__user"
						data-qa="profile-data-form"
						:class="{ 'wrapper__form__user--without-photo': !profilePhotoEnabled }"
						@submit.prevent="updateMember"
					>

						<ProfilePhotoUpload
							v-if="profilePhotoEnabled"
							ref="profilePhotoUpload"
							class="wrapper__form--imagem"
							:avatar-url="avatarUrl"
							:disabled="isSavingAvatar"
							@file-selected="handleAvatarFile"
						/>


						<div class="wrapper__form--data">
							<h2 class="profile__form-title">{{ $t('myArea.personalDataTitle') }}</h2>


							<div class="row">
								<FormInput data-qa="profile-email-input" :label="$t('form.labels.mail')" inputId="mail" inputType="email"
									:placeholder="$t('form.placeholder.email')" :isRequired="true" v-model="user.email"
									:isError="sending && !loginValidation.email"
									:messageError="$t('form.messageError.email')" :isDisabled="true" :col="'col-50'" />

								<FormInputCPF data-qa="profile-tax-id-input" :label="$t('form.labels.cpf')" inputId="cpf" inputType="text" :placeholder="$t('form.labels.cpf')" v-model="user.member.taxId"
									:isRequired="true" :col="'col-50'" :isDisabled="!isEditingProfile || isTaxIdLocked"
									:isError="(sending && cpfEnabled && !loginValidation.taxId) || taxIdError" :messageError="taxIdError ? $t('myArea.taxId.alreadyExists') : $t('form.messageError.cpf')" />
							</div>

							<div class="row">
								<FormInput data-qa="profile-first-name-input" :label="$t('form.labels.name')" inputId="nome" inputType="text"
									:isError="sending && !loginValidation.name"
									:placeholder="$t('form.labels.name')" v-model="this.user.name" :isRequired="true" :col="'col-50'"
									:isDisabled="!isEditingProfile" :messageError="$t('form.messageError.name')" letters-only />

								<FormInput data-qa="profile-last-name-input" :label="$t('form.labels.sobrenome')" inputId="sobrenome" inputType="text" v-model="user.lastName"
									:isError="sending && !loginValidation.lastName"
									:placeholder="$t('form.labels.sobrenome')" :isRequired="true" :col="'col-50'"
									:isDisabled="!isEditingProfile" :messageError="$t('form.messageError.lastName')" letters-only />
							</div>

							<div class="row ">

								<FormInput data-qa="profile-birth-date-input" :label="$t('form.labels.nascimento')" inputId="nascimento" inputType="text" v-model="user.birthday"
									:mask="$t('form.labels.birthdayMask')" :isError="sending && !loginValidation.birthday"
									:placeholder="$t('form.labels.nascimento')" :isRequired="true" :col="'col-33'"
									:isDisabled="!isEditingProfile" :messageError="$t('form.messageError.birthday')" />

								<FormInput data-qa="profile-cellphone-input" :label="$t('form.labels.celular')" inputId="tel" inputType="tel" v-model="user.member.cellphone"
									:isError="sending && !loginValidation.cellphone"
									:mask="user.member.cellphone === cellphoneMasked ? '' : $t('form.labels.telMask')"
									:placeholder="$t('form.labels.celular')" :isRequired="true" :col="'col-33'"
									:isDisabled="!isEditingProfile"
									@focus="onCellphoneFocus" @blur="onCellphoneBlur"
									:messageError="$t('form.messageError.cellphone')" />


								<FormInputSelect data-qa="profile-gender-select" :label="$t('form.labels.gender')" :isRequired="false" inputId="month" :col="'col-32'"
									:messageError="$t('form.messageError.correctly')" :placeholder="$t('form.labels.gender')" v-model="user.member.genderId"
									:isDisabled="!isEditingProfile">
									<option value="1">{{ $t('form.gender.male') }}</option>
									<option value="2">{{ $t('form.gender.female') }}</option>
									<option value="3">{{ $t('form.gender.preferNotAnswer') }}</option>
								</FormInputSelect>
							</div>


							<h2 class="profile__form-title profile__form-title--address">{{ $t('myArea.addressTitle') }}</h2>

							<div class="row">
								<FormInput data-qa="profile-zip-code-input" :label="$t('form.labels.zipCode')" inputId="cep" inputType="text" :mask="$t('form.labels.cepMask')"
									:placeholder="$t('form.labels.zipCode')" :isRequired="true" :col="'col-50'" v-model="user.member.memberAddress.zipCode"
									:isError="(sending && !loginValidation.zipCode) || (sending && !loginValidation.zipCode)"
									:isDisabled="!isEditingProfile"
									:messageError="zipCodeError ? zipCodeErrorMessage : (sending && !loginValidation.zipCode ? $t('form.messageError.zipCode') : '')"
									@blur="onCepBlur" />
								<FormInput data-qa="profile-address-input" :label="$t('form.labels.endereco')" inputId="rua" inputType="text" :placeholder="$t('form.labels.endereco')" v-model="user.member.memberAddress.address"
									:isRequired="true" :col="'col-50'" :isError="sending && !loginValidation.address"
									:isDisabled="!isEditingProfile" :messageError="$t('form.messageError.address')" />
							</div>

							<div class="row">
								<FormInput data-qa="profile-address-number-input" :label="$t('form.labels.number')" inputId="address-number" inputType="text" :placeholder="$t('form.labels.number')" v-model="user.member.memberAddress.number"
									:isRequired="true" :col="'col-50'" :messageError="$t('form.messageError.correctlyFull')"
									:isDisabled="!isEditingProfile" :isError="sending && !loginValidation.number"/>
								<FormInput data-qa="profile-address-complement-input" :label="$t('form.labels.complemento')" inputId="address-complement" inputType="text" v-model="user.member.memberAddress.complement"
									:placeholder="$t('form.labels.complemento')" :isRequired="false" :col="'col-50'"
									:isDisabled="!isEditingProfile" :messageError="$t('form.messageError.correctlyFull')" :isError="false" />
							</div>

							<div class="row">

								<FormInput data-qa="profile-address-neighborhood-input" :label="$t('form.labels.neighborhood')" inputId="address-neighborhood" inputType="text" :placeholder="$t('form.labels.neighborhood')" v-model="user.member.memberAddress.neighborhood"
									:isRequired="false" :col="'col-33'" :messageError="$t('form.messageError.correctlyFull')" :isError="false"
									:isDisabled="!isEditingProfile" />

								<FormInputSelect v-if="isBrazilMarket" data-qa="profile-address-state-select" :label="$t('form.labels.state')" :isRequired="true" inputId="address-state" :col="'col-32'" v-model="user.member.memberAddress.state"
									:messageError="$t('form.messageError.correctlyFull')" @change="onStateChange()" :placeholder="$t('form.labels.state')" :isError="sending && !loginValidation.state"
									:isDisabled="!isEditingProfile"
									>	
									<option v-for="state in states" :key="state.id" :value="state.sigla" data-qa="profile-address-state-item" :data-qa-id="state.id">  {{ state.nome }}</option>
								</FormInputSelect>

								<FormInputSelect v-if="isBrazilMarket"  data-qa="profile-address-city-select" :label="$t('form.labels.city')" :isRequired="true" v-model="user.member.memberAddress.city" inputId="address-city" :col="'col-33'"
									:messageError="$t('form.messageError.correctly')" :placeholder="$t('form.labels.city')" :isError="sending && !loginValidation.city"
									:isDisabled="!isEditingProfile"
									>
									<option v-for="city in cities" :key="city.id || city.nome" :value="city.nome" data-qa="profile-address-city-item" :data-qa-id="city.id || city.nome">  {{ city.nome }}</option>
								</FormInputSelect>

								<!-- Latam -->
								<FormInput v-if="!isBrazilMarket" data-qa="profile-address-state-input" :label="$t('form.labels.state')" inputId="address-state" inputType="text" :placeholder="$t('form.labels.state')" v-model="user.member.memberAddress.state"
									:isRequired="true" :col="'col-33'" :messageError="$t('form.messageError.correctlyFull')" :isError="sending && !loginValidation.state"
									:isDisabled="!isEditingProfile" letters-only />

								<FormInput v-if="!isBrazilMarket" data-qa="profile-address-city-input" :label="$t('form.labels.city')" inputId="address-city" inputType="text" :placeholder="$t('form.labels.city')" v-model="user.member.memberAddress.city"
									:isRequired="true" :col="'col-33'" :messageError="$t('form.messageError.correctly')" :isError="sending && !loginValidation.city"
									:isDisabled="!isEditingProfile" letters-only />
								<!-- Latam -->

							</div>
							<div class="btn__form">
								<AppButton v-if="!isEditingProfile" data-qa="profile-edit-button" type="button" variant="secondary" @click="startProfileEditing">
									{{ $t('buttons.editProfile') }}
								</AppButton>
								<div v-else class="profile__form-actions">
									<AppButton data-qa="profile-save-button" type="submit" :disabled="isSavingProfile" :aria-busy="isSavingProfile" variant="primary">
										{{ $t(isSavingProfile ? 'buttons.saving' : 'buttons.saveProfile') }}
									</AppButton>
									<AppButton data-qa="profile-cancel-button" type="button" :disabled="isSavingProfile" variant="secondary" @click="cancelProfileEditing">
										{{ $t('buttons.cancelar') }}
									</AppButton>
								</div>
								<Transition name="profile-feedback">
									<p v-if="profileUpdateSuccess" class="profile__feedback" data-qa="profile-data-success" role="status">
										<Icons name="check" aria-hidden="true" />
										{{ $t('myArea.dataSuccess') }}
									</p>
								</Transition>
							</div>
						</div>

					</form>
				</div>

			</div>



		</section>
		<!-- [END] FORM PERFIL ==================================== -->


		<ProfileProducts
			ref="profileProducts"
			v-show="activeProfileSection === 'products'"
			:products="products"
			:categories="categories"
			:sub-categories="subCategories"
			:is-saving="isSavingProduct"
			:deleting-product-ids="deletingProductIds"
			:reset-key="productFormResetKey"
			:success-message="productUpdateSuccess"
			:request-error="productUpdateError"
			@dirty-change="handleProductDirtyChange"
			@load-categories="loadCategories"
			@load-sub-categories="onCategoryChange"
			@save="saveProduct"
			@delete="requestProductDelete"
		/>


		<!-- [START] INDICAÇÕES ==================================== -->
		<section
			v-show="activeProfileSection === 'referrals'"
			class="referrals-section"
			data-qa="profile-referrals-section"
			:aria-labelledby="'referrals-section-title'"
		>
			<h2 id="referrals-section-title" class="referrals-section__title">
				{{ $t('myArea.activities.referralsTitle') }}
			</h2>

			<div class="referrals-card referrals-card--with-history">
				<div class="referrals-card__history">
					<div class="referrals-card__counters">
						<div class="referrals-card__counter">
							<strong data-qa="profile-referrals-confirmed-text">{{ mgmConfirmedCount }}</strong>
							<span>{{ $t('myArea.activities.counters.confirmed') }}</span>
						</div>
						<div class="referrals-card__counter">
							<strong data-qa="profile-referrals-pending-text">{{ mgmPendingCount }}</strong>
							<span>{{ $t('myArea.activities.counters.pending') }}</span>
						</div>
						<div class="referrals-card__counter">
							<strong data-qa="profile-referrals-total-text">{{ mgmConfirmedCount + mgmPendingCount }}</strong>
							<span>{{ $t('myArea.activities.counters.total') }}</span>
						</div>
					</div>

					<div class="referrals-card__table-wrap">
					<table class="referrals-card__table" data-qa="profile-referrals-table">
							<thead>
								<tr>
									<th scope="col">{{ $t('myArea.activities.table.sentEmails') }}</th>
									<th scope="col">{{ $t('myArea.activities.table.status') }}</th>
								</tr>
							</thead>
							<tbody>
							<tr v-if="!mgmHasMgmListSection" data-qa="profile-referrals-empty">
									<td colspan="2" class="referrals-card__empty">
										{{ $t('myArea.activities.empty') }}
									</td>
								</tr>
							<tr
								v-for="(activity, index) in mgmConfirmedActivities.concat(mgmPendingActivities)"
								:key="`${activity.email}-${mgmConfirmedActivities.includes(activity) ? 'confirmed' : 'pending'}-${index}`"
								data-qa="profile-referrals-table-row"
								:data-qa-id="activity.id || activity.email"
							>
								<td data-qa="profile-referrals-email-text" :data-qa-id="activity.id || activity.email">{{ activity.email }}</td>
									<td>
										<span
											class="referrals-card__status"
											data-qa="profile-referrals-status-badge"
											:data-qa-id="activity.id || activity.email"
											:class="{ 'referrals-card__status--pending': !mgmConfirmedActivities.includes(activity) }"
										>
											<Icons :name="mgmConfirmedActivities.includes(activity) ? 'checkMark' : 'pendingMark'" />
											{{ $t(mgmConfirmedActivities.includes(activity) ? 'myArea.activities.confirmedLabel' : 'myArea.activities.pendingLabel') }}
										</span>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>

				<MGMComponent
					data-qa="profile-referrals-invite-section"
					:show-image="false"
					:referral-link="mgmReferralLink"
					:send-invite-request="mgmSendInviteRequest"
					@send-invite="handleMgmSendInvite"
					@copy-success="handleMgmCopySuccess"
					@copy-error="handleMgmCopyError"
				/>
			</div>
		</section>
		<!-- [END] INDICAÇÕES ==================================== -->




	</section>
</template>
<style lang="sass" scoped>
@use '../assets/sass/common/_profile' as *

:deep(.product-delete-confirmation)
	display: flex
	flex-direction: column
	gap: 1.5rem

:deep(.product-delete-confirmation__message)
	display: flex
	flex-direction: column
	gap: 0.75rem

:deep(.product-delete-confirmation__message p)
	margin: 0

:deep(.product-delete-confirmation__error)
	display: flex
	align-items: center
	gap: 0.5rem
	margin: 0
	padding: 0.5rem 1rem
	border-radius: 0.5rem
	background-color: rgba(var(--lg-red-active-rgb), 0.1)
	color: var(--lg-red-active)
	font-family: var(--lgei-text)
	font-size: 0.875rem

	i
		width: 1.25rem
		height: 1.25rem

:deep(.product-delete-confirmation__actions)
	gap: 1rem

:deep(.profile-unsaved-confirmation)
	display: flex
	flex-direction: column
	gap: 1.5rem
	width: min(32rem, calc(100vw - 2rem))

:deep(.profile-unsaved-confirmation__message)
	margin: 0
	color: var(--club--text-default)
	font-family: var(--lgei-text)
	font-size: 1rem
	line-height: 1.4
	text-align: center

:deep(.profile-unsaved-confirmation__actions)
	flex-wrap: wrap
	gap: 1rem
</style>
